import React from 'react'
import './index.sass'

const Controls = ({ isPlaying, setPlaying, setCurrentIndex, currentIndex, lastIndex }) => (
  <div className='controls-wrapper'>
    <button
      disabled={currentIndex === 0}
      className="btn audio-controls audio-controls-prev"
      onClick={() => setCurrentIndex(currentIndex - 1)}
    />
    {isPlaying ? (
      <button className="btn audio-controls audio-controls-pause" onClick={setPlaying} />
    ) : (
      <button className="btn audio-controls audio-controls-play" onClick={setPlaying} />
    )}
    <button
      disabled={currentIndex === lastIndex}
      className="btn audio-controls audio-controls-next"
      onClick={() => setCurrentIndex(currentIndex + 1)}
    />
  </div>
)

export default Controls
